import { Blueprint } from "../../base/blueprints/Blueprint";

export interface HasServerSideTriggers extends Blueprint
{
    serverSideTriggerMoments: TriggerMoments[];
    serverSideTriggers: TriggerModel[];
}

export interface HasClientSideTriggers extends Blueprint
{
    clientSideTriggerMoments: TriggerMoments[];
    clientSideTriggers: TriggerModel[];
}

export const instanceOfHasServerSideTriggers = (object: any): object is HasServerSideTriggers =>
{
    return object && 'serverSideTriggers' in object;
};

export const instanceOfHasClientSideTriggers = (object: any): object is HasClientSideTriggers =>
{
    return object && 'clientSideTriggers' in object;
};

export interface TriggerModel
{
    id: string;
    expanded: boolean;
    moment: any;
    script: any;
    scriptConfigId: string;
}

export enum TriggerMoments {
    onLoad = 'onLoad',
    onChange = 'onChange'
}

export enum TriggerModes {
    ServerSide = 'ServerSide',
    ClientSide = 'ClientSide'
}
